export default __webpack_public_path__ + "67215934998b17efa63fb306f23180fa.woff2";